export default `
  .tippy-tooltip {
    background-color: transparent !important;
  }

  .tippy-backdrop {
    display: none;
  }
`
